import { createFileRoute, redirect } from '@tanstack/react-router';

import { LlmModelsAdmin } from '@/components/features/admin/llm-models/LlmModelsAdmin';
import { ErrorBoundary, ErrorFallback } from '@/modus/ErrorBoundary';
import { userHasRole } from '@/utils/roles';

export const Route = createFileRoute('/_protected/llm-models')({
  beforeLoad: ({ context }) => {
    if (!userHasRole(context.user, 'llm-usage-dashboard-admin')) {
      throw redirect({ to: '/', replace: true });
    }
  },
  component: LlmModelsAdminRoute,
});

function LlmModelsAdminRoute() {
  return (
    <ErrorBoundary fallback={(error) => <ErrorFallback error={error} />}>
      <LlmModelsAdmin />
    </ErrorBoundary>
  );
}
